import { Router } from "@remix-run/router";
import { getBackUrl } from "../../../helpers/useBackNavigate";

export const patchRouterBackUrl = (router: Router) => {
  const originalNavigate = router.navigate;
  router.navigate = (...args) => {
    const opts = args[1] as any;
    if (opts) {
      const { location: { pathname, search } } = window;
      if (!opts.state || !opts.state.backUrl) {
        const { BASE_URL } = window.ENV;

        const backUrl = opts.replace
          ? getBackUrl()
          : (BASE_URL ? pathname.slice(`${BASE_URL}/`.length) : pathname) + search;

        opts.state = {
          ...opts.state,
          backUrl
        };
      }
    }
    //@ts-ignore
    return originalNavigate(...args);
  }
  return router;
}